import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ChatMessageList2SF from '../../../components/superUser/account/ChatMessageList2SF.js'
import SuperUserAccountNameUI from '../../../templates/SuperUserAccountNameUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SwitchUI from '../../../widgets/action/SwitchUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import LRTableRowLinkUI from '../../../widgets/layout/LRTableRowLinkUI.js'
import BadgeUI from '../../../widgets/output/BadgeUI.js'

const AccountChatPageUI = ({ context, account, user, errorList, userMessageList, draftMessageList,
  onRefreshClick, selectedRowId, filteredList, userList, deleteSubmitted, onDeleteClick,
  searchFilter, onSearchFilterChange, checked, onShowUnread
}) =>
  <SuperUserAccountNameUI context={context} className='pg_su_chat' accountUserList={filteredList}
    centered={!userList} page={user && user.userId} dimension='w1000'
    topnav='chats' searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
    checked={checked} onShowUnread={onShowUnread}
  >
    {
      !userList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && userList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              {/*
            context.permissions.includes('su_manage') &&
            <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onWriteClick} label='Write Message' />
          */}
              <span className='g_m_left_100 g_large'><b>{account.accountName}</b></span>
            </div>
          }
          right={<span />}
        />

        <LRTableBodyUI>
          {
            userList && userList.map((user) =>
              <UserListUI key={user.userId} label={user.userName} to={`/su/accounts/${user.accountId}/users/${user.userId}/chats`}
                message={user.latestDraftMessage !== null ? user.latestDraftMessage : user.latestMessage}
                unreadMessages={user.noOfUnreadMessages} accountName={user.accountName} />
            )
          }
        </LRTableBodyUI>
      </div>
    }
    {
      userList && userList.length === 0 &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createDisabledMessageLabel='No users'
      />
    }
  </SuperUserAccountNameUI>

const UserListUI = ({ label, message, to, active, unreadMessages, accountName }) =>
  <div>
    {
      message &&
      <LRTableRowLinkUI
        left={
          <div className='g_flex_v'>
            {/* <span className='g_small g_muted'>{accountName}</span> */}
            <span className="account_name">{label}</span>
            <span className={message.status === 'draft' ? 'account_message g_success' : message.csr ? "account_message g_muted" : "account_message g_error"}>
              {message.status === 'draft' ? `draft: ${message.message}` : message.message}
            </span>
          </div>
        }
        right={
          <div className='g_flex_v'>
            <span className='g_flex_h g_flex_right g_m_bottom_100'>
              {
                unreadMessages !== 0 &&
                <BadgeUI label={unreadMessages} />
              }
            </span>
            <span className={message.csr ? "account_time g_muted" : "account_time g_error"}>
              {message.messageDate - Date.now() >= 3 ? message.messageDateTimeF.split(" ")[0] : message.messageDateTimeF.split(" ")[1]}
              {/* {message.messageDateTimeF.split(" ")[1]} Extracts only the time */}
            </span>
          </div>
        }
        to={to}
      />
    }
  </div>

export default AccountChatPageUI
